function prevent(_target, _propertyKey, descriptor) {
  const next = descriptor.value;

  Object.assign(descriptor, {
    value(event) {
      event instanceof Event && event.preventDefault();
      return Reflect.apply(next, this, arguments);
    },
  });
}

export default prevent;
